<template>
  <div>
    <div>
      <!-- <CustomLoader v-if="isLoading" :width="70"></CustomLoader> -->
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <!-- Profit Loss Summary Section Start -->
    <!-- <div class="row">
      <div class="col-md-6">
        <h5>
          <b-badge :variant="'info'">{{ Page_title }}</b-badge>
        </h5>
      </div> -->
       <b-row>
          <b-col md="3">
            <h5><b-badge :variant="'info'">{{ Page_title }}</b-badge></h5>
          </b-col>
          
          <!-- <b-col md="2">
             <model-list-select
                :list="CustomDateList"
                v-model="typeFilter"
                class="mb-1"
                option-value="DVal"
                option-text="DText"
                placeholder="Select"
                @input="getProfitLossGrowthCard('Normal')"
              ></model-list-select>
          </b-col> -->
           <b-col md="3">
             <b-button
          class="pull-right mb-1 ml-1 mr-1"
          v-if="PLCList.length > 0"
          :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
          @click="getReports('getProfitLossGrowthCard', 'Export As Excel')"
          size="sm"
          variant="warning"
          style="font-size: 0.675rem"
        >
          {{ ExcelBtnName }}
          <b-spinner
            v-if="ExcelBtnName != 'Export As Excel'"
            small
            label="Small Spinner"
          ></b-spinner
        ></b-button>
             <b-button
          class="pull-right mb-1"
          v-if="PLCList.length > 0"
          :disabled="ExcelBtnName1 != 'Export As All Split Excel' ? true : false"
          @click="getReportsExpInvAll('getProfitLossINVGrowthCard', 'Export As All Split Excel','INV',1)"
          size="sm"
          variant="warning"
          style="font-size: 0.675rem"
        >
          {{ ExcelBtnName1 }}
          <b-spinner
            v-if="ExcelBtnName1 != 'Export As All Split Excel'"
            small
            label="Small Spinner"
          ></b-spinner
        ></b-button>
           </b-col>
        </b-row>
              <b-row v-if="PMC_showInternalFilters">
                <b-col md="2"></b-col>
                <!-- <b-col md="2"></b-col>

                <b-col md="1">
                  <model-list-select
                    :list="CustomDateList"
                    v-model="QDFilter"
                    class="mb-1"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    :isDisabled="QFlag"
                    @input="getCurrentLastDate"
                  ></model-list-select>
                </b-col> -->
                <b-col md="3">
                  <date-range-picker
                    class="mb-1"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="DFlag ? true : false"
                    @update="getProfitLossGrowthCard('Normal')"
                  ></date-range-picker>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    class="mb-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getProfitLossGrowthCard('Normal')"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    :list="CustomTypeList"
                    v-model="typeFilter"
                    class="mb-1"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getProfitLossGrowthCard('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="1">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="mb-1"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                
                
                </b-col>
                </b-row>
      <div class="col-md-12">
        <b-table
          show-empty
          stacked="md"
          :items="PLCList"
          :fields="typeFilter=='Voucher'?VoucherPLCfields:PLCfields"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template slot="SN" slot-scope="row0">
            <!-- {{row0.item}} -->
            <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
          </template>
           <template slot="tot_inv" slot-scope="row1">
            <b-button
            v-if="typeFilter=='ASSIGNMENT'"
              class="pull-right mb-1 ml-1 mr-1"
              @click="getReportsExpInv('getProfitLossINVGrowthCard', 'Export As Excel',row1.item.DRow,'INV',1,'module')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >Split</b-button>
            
             <b-button
             v-if="row1.item.month!='Final Total'"
              class="pull-right mb-1"
              @click="getReportsExpInv('getProfitLossINVGrowthCard', 'Export As Excel',row1.item.DRow,'INV',0,'module')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >{{ row1.item.tot_inv }}</b-button>
            <span class="pull-right mb-1" v-else>{{ row1.item.tot_inv }}</span>
          </template>
            <template slot="tot_exp" slot-scope="row2">
               <!-- <b-button
               v-if="typeFilter=='ASSIGNMENT'"
              class="pull-right mb-1 ml-1 mr-1"
              @click="getReportsExpInv('getProfitLossEXPGrowthCard', 'Export As Excel',row2.item.DRow,'EXP',1)"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >Splited Exp</b-button> -->
              <b-button
              v-if="row2.item.month!='Final Total'"
              class="pull-right mb-1"
              @click="getReportsExpInv('getProfitLossEXPGrowthCard', 'Export As Excel',row2.item.DRow,'EXP',0,'module')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >{{ row2.item.tot_exp }}</b-button>
            <span class="pull-right mb-1"  v-else>{{ row2.item.tot_exp }}</span>
          </template>


  <template slot="tot_withoutModule_inv1" slot-scope="row1">
      
            
             <b-button
             v-if="row1.item.month!='Final Total'"
              class="pull-right mb-1"
              @click="getReportsExpInv('getProfitLossINVGrowthCard', 'Export As Excel',row1.item.DRow,'INV',0,'without')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >{{ row1.item.tot_withoutModule_inv1 }}</b-button>
            <span class="pull-right mb-1" v-else>{{ row1.item.tot_withoutModule_inv1 }}</span>
          </template>
            <template slot="tot_withoutModule_exp1" slot-scope="row2">
               <!-- <b-button
               v-if="typeFilter=='ASSIGNMENT'"
              class="pull-right mb-1 ml-1 mr-1"
              @click="getReportsExpInv('getProfitLossEXPGrowthCard', 'Export As Excel',row2.item.DRow,'EXP',1)"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >Splited Exp</b-button> -->
              <b-button
              v-if="row2.item.month!='Final Total'"
              class="pull-right mb-1"
              @click="getReportsExpInv('getProfitLossEXPGrowthCard', 'Export As Excel',row2.item.DRow,'EXP',0,'without')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >{{ row2.item.tot_withoutModule_exp1 }}</b-button>
            <span class="pull-right mb-1"  v-else>{{ row2.item.tot_withoutModule_exp1 }}</span>
          </template>
        </b-table>

      </div>
    </div>

    <!-- Profit Loss Summary Section End -->
  
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
// import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import ProfitLossService from "../../services/ProfitLossService.js";
import DateRangePicker from "vue2-daterange-picker";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },

    PMC_QDFilter: {
      type: String,
      default: "",
    },
    PMC_dateRange: {
      type: Object,
      default: "",
    },
    PMC_startDate: {
      type: String,
      default: "",
    },
    PMC_endDate: {
      type: String,
      default: "",
    },
    PMC_branchfilter: {
      type: String,
      default: "",
    },
    PMC_DFlag: {
      type: Boolean,
      default: false,
    },
    PMC_QFlag: {
      type: Boolean,
      default: false,
    },
    PMC_ProfitLossCardFlag: {
      type: Boolean,
      default: false,
    },
    PMC_typeFilter: {
      type: String,
      default: "",
    },
    PMC_showInternalFilters: {
      type: Boolean,
      default: true,
    },
  },

  beforeMount() {
    // alert(this.PMC_typeFilter)
    this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
    if (
      this.PMC_dateRange.startDate ||
      this.PMC_QDFilter ||
      this.PMC_DFlag ||
      this.PMC_QFlag ||
      this.PMC_branchfilter ||
      this.PMC_ProfitLossCardFlag ||
      this.PMC_typeFilter
    ) {
      this.getProfitLossGrowthCard("Normal");
    }
  },
  mounted() {},

  data() {
    return {
      QFlag: false,
      DFlag: false,
       CustomTypeList: [
        {
          DVal: "ASSIGNMENT",
          DText: "ASSIGNMENT",//ASSIGNMENT
        },
        {
          DVal: "VOUCHER",
          DText: "VOUCHER",//VOUCHER
        },
      ],
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      QDFilter: "",
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export As All Split Excel",
      
      typeFilter: "ASSIGNMENT",
      Page_title: this.PMC_title,
      docURL: URL_BASE_DOC,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      PLCfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "month",
          mainkey: "month",
          label: "Month",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "tot_inv",
          mainkey: "tot_inv",
          label: "Tot Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "tot_exp",
          mainkey: "tot_exp",
          label: "Tot Exp",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        // {
        //   key: "inv_exp_minus",
        //   mainkey: "inv_exp_minus",
        //   label: "Inv-Exp",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "E.",
        // },
        {
          key: "TPL_AMT",
          mainkey: "TPL_AMT",
          label: "Tot Profit Loss AMT",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "PLP",
          mainkey: "PLP",
          label: "Profit Loss %",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "tot_withoutModule_inv1",
          mainkey: "tot_withoutModule_inv1",
          label: "Without Module INV",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },

        {
          key: "tot_withoutModule_exp1",
          mainkey: "tot_withoutModule_exp1",
          label: "Without Module Exp",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
      ],
      VoucherPLCfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "month",
          mainkey: "month",
          label: "Month",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "tot_inv",
          mainkey: "tot_inv",
          label: "Tot Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "tot_exp",
          mainkey: "tot_exp",
          label: "Tot Exp",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "TPL_AMT",
          mainkey: "TPL_AMT",
          label: "Tot Profit Loss AMT",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "PLP",
          mainkey: "PLP",
          label: "Profit Loss %",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },
      ],
      PLCList: [],
      branchfilter:"",

      // isLoading: false,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    //  CustomLoader,
    DatePicker,
    ModelListSelect,
     DateRangePicker,
  },

  computed: {},
  watch: {
    // JOBSERIES: {
    //   handler: function (newVal, oldVal) {
    //     this.getProfitLossGrowthCard("Normal");
    //   },
    //   deep: true,
    // },
    PMC_typeFilter: {
      handler: function (newVal, oldVal) {
        // Handle the updated value
        this.getProfitLossGrowthCard("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getEffectiveDateRange() {
      const sourceRange = this.PMC_showInternalFilters
        ? this.dateRange
        : this.PMC_dateRange || this.dateRange;

      const formatToYmd = (value) => {
        if (!value) return "";
        const m = moment(value);
        return m.isValid() ? m.format("YYYY-MM-DD") : "";
      };

      return {
        startDate: formatToYmd(sourceRange && sourceRange.startDate),
        endDate: formatToYmd(sourceRange && sourceRange.endDate),
      };
    },
    getEffectiveBranchFilter() {
      if (this.PMC_showInternalFilters) return this.branchfilter;
      return this.PMC_branchfilter || this.branchfilter;
    },
    getEffectiveTypeFilter() {
      if (this.PMC_showInternalFilters) return this.typeFilter;
      return this.PMC_typeFilter || this.typeFilter;
    },
     clearFilter() {
      this.QFlag = false;
      this.DFlag = false;
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.branchfilter="";
      this.branchfilter = "";
      this.branchfilterName = "";
      this.QDFilter = "";


  
     
    },
    getCurrentLastDate() {
      let firstDay = null;
      let lastDay = null;
      const now = new Date();
      var today = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const economicYearStartMonth = 3; // April is the 4th month (0-based index)
      const economicYearEndMonth = 2; // March is the 3rd month (0-based index)
      let currentYearStart = null;
      let currentYearEnd = null;

      if (currentMonth >= economicYearStartMonth) {
        currentYearStart = currentYear;
        currentYearEnd = currentYear + 1;
      } else {
        currentYearStart = currentYear - 1;
        currentYearEnd = currentYear;
      }
      if (this.QDFilter) {
        var Qdate = this.QDFilter;
        switch (Qdate) {
          case "Q1": {
            firstDay = new Date(currentYearStart, economicYearStartMonth, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 2, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q2": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 3, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 5, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q3": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 6, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 8, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q4": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 9, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearEnd, economicYearEndMonth, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "H1": {
            firstDay = new Date(currentYearStart, economicYearStartMonth, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 5, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "H2": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 6, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearEnd, economicYearEndMonth, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          default: {
            // alert(">41");//.toLocaleDateString('en-GB')
          }
        }
        this.QFlag = false;
        this.DFlag = true;
        this.clearFilter();
      } else if (!this.QDFilter) {
        this.QFlag = true;
        this.DFlag = false;
        this.clearFilter();
      }
      console.log("firstDay=>", firstDay);
      console.log("lastDay=>", lastDay);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getProfitLossGrowthCard('Normal');
    },
    getReports(id, btnName) {
      // this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getProfitLossGrowthCard("Excell");
    },
    getReportsExpInvAll(id, btnName, ExpInvType, isSplited) {
      const activeDateRange = this.getEffectiveDateRange();
      let DateRange = {
        from: activeDateRange.startDate,
        to: activeDateRange.endDate,
      };
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      this.getProfitLossINVExpGrowthCard(
        id,
        "Excell",
        DateRange,
        ExpInvType,
        isSplited,
      ''
      );
    },
    getReportsExpInv(id, btnName, DateRange, ExpInvType, isSplited,moduleType) {
      // this.isLoading = true;
      this.getProfitLossINVExpGrowthCard(
        id,
        "Excell",
        DateRange,
        ExpInvType,
        isSplited,
        moduleType
      );
    },
    getProfitLossINVExpGrowthCard(id, type, DateRange, ExpInvType, isSplited,moduleType) {
      let payload = {};
      this.ExcelBtnName1 = "Export As All Split Excel";
      const effectiveBranchFilter = this.getEffectiveBranchFilter();
      const effectiveTypeFilter = this.getEffectiveTypeFilter();
      let dateRangeFilter = {
        startDate: DateRange.from,
        endDate: DateRange.to,
      };
      console.log("PS this.PMC_typeFilter=>", this.PMC_typeFilter);

      payload = {
        itemCode: id,
        // PHP API expects filters under `Filter`
        Filter: {
          dateRange: dateRangeFilter,
          branchfilter: effectiveBranchFilter,
          typeFilter: effectiveTypeFilter,
        },
        // keep legacy top-level keys too (backward compatible)
        dateRange: dateRangeFilter,
        branchfilter: effectiveBranchFilter,
        type: type,
        ExpInvType: ExpInvType,
        typeFilter: effectiveTypeFilter,
        isSplited: isSplited,
        moduleType:moduleType,
      };

      ProfitLossService.getAllProfitLoss(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.isLoading = false;
            if (type == "Excell") {
               window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
               data.excelName;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on PLCList Error: ", error);
        });
    },
    getProfitLossGrowthCard(type) {
      // this.isLoading = true;
      this.PLCList = [];
      const effectiveDateRange = this.getEffectiveDateRange();
      const effectiveBranchFilter = this.getEffectiveBranchFilter();
      const effectiveTypeFilter = this.getEffectiveTypeFilter();
      let effectiveQDFilter = this.PMC_showInternalFilters
        ? this.QDFilter
        : this.PMC_QDFilter;

      // Parent-selected explicit date range must take priority over quarter shortcuts.
      if (
        !this.PMC_showInternalFilters &&
        effectiveDateRange.startDate &&
        effectiveDateRange.endDate
      ) {
        effectiveQDFilter = "";
      }
      let effectiveQFlag = false;
      let effectiveDFlag = false;
      if (effectiveQDFilter) {
        effectiveQFlag = false;
        effectiveDFlag = true;
      } else if (effectiveDateRange.startDate && effectiveQDFilter == "") {
        effectiveQFlag = true;
        effectiveDFlag = false;
      }
      let payload = {};
      if (
        effectiveDateRange.startDate ||
        effectiveQDFilter ||
        effectiveDFlag ||
        effectiveQFlag ||
        effectiveBranchFilter ||
        this.PMC_ProfitLossCardFlag ||
        effectiveTypeFilter
      ) {
        payload = {
          itemCode: "getProfitLossGrowthCard",
          // PHP API expects filters under `Filter`
          Filter: {
            dateRange: effectiveDateRange,
            branchfilter: effectiveBranchFilter,
            QDFilter: effectiveQDFilter,
            typeFilter: effectiveTypeFilter,
          },
          // keep legacy top-level keys too (backward compatible)
          dateRange: effectiveDateRange,
          branchfilter: effectiveBranchFilter,
          QDFilter: effectiveQDFilter,
          typeFilter: effectiveTypeFilter,
          type: type,
        };
        console.log(" this.PMC_typeFilter=>", effectiveTypeFilter);
        ProfitLossService.getAllProfitLoss(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("response=>", response);
            if (status == 200 && data) {
              // this.isLoading = false;
              if (type == "Excell") {
                if (data.PLCList.length > 0) {
                  this.PLCList = data.PLCList;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` +
                  data.excelName;
              } else {
                if (data.PLCList.length > 0) {
                  this.PLCList = data.PLCList;
                }
              }
            }
          })
          .catch((error) => {
            console.log("Catch on PLCList Error: ", error);
          });
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// profitLossGrowthPaymentCard.vue?ebeac84a